module.exports = __webpack_public_path__ + "img/source3_7.c1fbad2b.png";